const CalculatorList = {
  borrowingCapacity: "borrowingCapacity",
  refinance: "refinance",
  mortgageRepayment: "mortgageRepayment",
};

export default CalculatorList;
